export default __webpack_public_path__ + "static/media/Seal.ebb4aaf9.png";